<template>
  <v-card class="information-card">
    <v-card-title>
      Cohort Details
    </v-card-title>
    <v-card-text>

      <div class="m">
        <div class="font-weight-bold mb-1">
          {{ $t('common.entities.Cohort') }}
        </div>
        <div>
          {{ cohort.title }}
        </div>
      </div>

      <v-divider class="my-3"/>
      <div>
        <div class="font-weight-bold mb-1">
          Active
        </div>
        <div>
          <v-chip size="small" :color="cohort.active ? 'green' : 'red'" variant="tonal">
            {{ cohort.active ? 'Enabled' : 'Disabled' }}
          </v-chip>
        </div>
      </div>
      <v-divider class="my-3"/>
      <div>
        <div class="font-weight-bold mb-1">
          Cohort Year Group
        </div>
        <div>
          {{ cohortYearGroup }}
        </div>
      </div>
      <v-divider class="my-3"/>
      <div>
        <div class="font-weight-bold mb-1">
          Cohort Exit Year
        </div>
        <div>
          {{ cohort.exitYear }}
        </div>
      </div>
      <v-divider class="my-3"/>
      <div>
        <div class="font-weight-bold mb-1">
          {{ $t('common.entities.Institution') }}
        </div>
        <div>
          {{ institutionTitle }}
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import {PropType} from "vue";
import {Cohort} from "@YenzaCT/sdk";
import {getSchoolYearFromExitYear} from "@/lib/util";

const props = defineProps({
  cohort: {
    type: Object as PropType<Cohort>,
    required: true
  }
});

const cohortYearGroup = props.cohort.exitYear ? getSchoolYearFromExitYear(props.cohort.exitYear) : undefined;

const institutionTitle = typeof props.cohort.institution === "string" ? props.cohort.institution : props.cohort.institution.title;
</script>
